var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire93b0"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire93b0"] = parcelRequire;
}
parcelRequire("aTIko");
const $7d9f01ff152f00eb$export$f3c6ed4330abfc18 = function() {
    return "#" + ("00000" + Math.floor(Math.random() * 16777216).toString(16)).slice(-6);
};
const $7d9f01ff152f00eb$export$5b36b6f0d685d40 = function(v) {
    var i = Math.floor(v * 6);
    var f = (v * 6 - i + 1) % 1;
    var q = ("0" + Math.round(255 * (1 - f)).toString(16)).slice(-2);
    var t = ("0" + Math.round(255 * f).toString(16)).slice(-2);
    switch((i + 6) % 6){
        case 0:
            return "#FF" + t + "00";
        case 1:
            return "#" + q + "FF00";
        case 2:
            return "#00FF" + t;
        case 3:
            return "#00" + q + "FF";
        case 4:
            return "#" + t + "00FF";
        case 5:
            return "#FF00" + q;
    }
};
const $7d9f01ff152f00eb$export$e54c95be12cf2344 = function(r, g, b) {
    return "#" + ("0" + Math.floor(r).toString(16)).slice(-2) + ("0" + Math.floor(g).toString(16)).slice(-2) + ("0" + Math.floor(b).toString(16)).slice(-2);
};


function $0ce5141a586bd8d5$export$f0a4cb52e779eda4(href) {
    // avoid duplicates
    for(let i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].href === href) return Promise.resolve();
    }
    return new Promise((resolve, reject)=>{
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
    });
}
function $0ce5141a586bd8d5$export$4b938d075d59879c(tag, rawProps) {
    const el = document.createElement(tag);
    const { children: children, ...otherProps } = rawProps;
    const props = otherProps;
    for(const key in props){
        if (key === "style") for(const key2 in props.style)el.style[key2] = props.style[key2];
        else if (typeof props[key] === "function" && key[0] === "o" && key[1] === "n") el.addEventListener(key.substr(2), props[key]);
        else el[key] = props[key];
    }
    function addChild(child) {
        if (child instanceof Array) child.forEach(addChild);
        else if (child instanceof Node) el.appendChild(child);
        else if (child) el.appendChild(document.createTextNode(String(child)));
    }
    if (children) addChild(children);
    return el;
}
function $0ce5141a586bd8d5$export$4a80062ca50b57c7(el, className, enabled) {
    const regexp = new RegExp("\\s*" + className, "g");
    if (typeof enabled === "undefined") enabled = !regexp.test(el.className);
    else if (enabled && regexp.test(el.className)) return;
    if (enabled) el.className += " " + className;
    else el.className = el.className.replace(regexp, "");
}


class $c2d7541b81dd5a64$export$2e2bcd8739ae039 {
    constructor(){
        this._listeners = {};
        this._queued = {};
        this._timeout = null;
    }
    on(type, callback) {
        let registered = this._listeners[type];
        if (!registered) {
            registered = [];
            this._listeners[type] = registered;
        }
        registered.push(callback);
    }
    emit(type, arg) {
        const registered = this._listeners[type];
        if (registered) registered.forEach((cb)=>cb.call(this, arg));
    }
    emitOnceAsync(type, arg) {
        this._queued[type] = arg;
        if (!this._timeout) this._timeout = setTimeout(()=>{
            this._timeout = null;
            const queued = this._queued;
            this._queued = {};
            for(const type in queued)this.emit(type, queued[type]);
        }, 0);
    }
    removeListener(type, callback) {
        const registered = this._listeners[type];
        if (registered) {
            const index = registered.indexOf(callback);
            if (index >= 0) registered.splice(index, 1);
        }
    }
}


parcelRequire("cPdJo");
// definition for a point quadtree. Useful every now and again.. especially when working with 2D grids ;)
class $4811c2f0f662c58f$export$2e2bcd8739ae039 {
    constructor(minx, miny, maxx, maxy){
        this.minx = minx;
        this.miny = miny;
        this.maxx = maxx;
        this.maxy = maxy;
        this.midx = (this.minx + this.maxx) / 2;
        this.midy = (this.miny + this.maxy) / 2;
        this.bucket = [];
        this.nw = null;
        this.ne = null;
        this.sw = null;
        this.se = null;
    }
    insert(obj) {
        // first make sure that the object goes inside our region.
        if (obj.x < this.minx || obj.x >= this.maxx || obj.y < this.miny || obj.y >= this.maxy) return false;
        // if we have no children,
        if (!this.nw) {
            // if we have not filled our own bucket, add to it.
            if (this.bucket.length < 5) {
                this.bucket.push(obj);
                return true;
            }
            // if we fill our own bucket, split up.
            this.subdivide();
        }
        // try storing the object in one of our children.
        return this.nw.insert(obj) || this.ne.insert(obj) || this.sw.insert(obj) || this.se.insert(obj);
    }
    subdivide() {
        // split up into four quadrants (child nodes)
        this.nw = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.minx, this.miny, this.midx, this.midy);
        this.ne = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.midx, this.miny, this.maxx, this.midy);
        this.sw = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.minx, this.midy, this.midx, this.maxy);
        this.se = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.midx, this.midy, this.maxx, this.maxy);
        // dump the contents of our bucket into our children
        for(var i = 0; i < this.bucket.length; i++)this.insert(this.bucket[i]);
        this.bucket = null;
    }
    inRegion(minx, miny, maxx, maxy) {
        // check that we overlap with the region
        if (maxx < this.minx || minx >= this.maxx || maxy < this.miny || miny >= this.maxy) return [];
        // if we have no children, return our bucket.
        // I decided not to copy the bucket, for speed reasons.
        if (!this.nw) return this.bucket;
        var found = [];
        // push the contents of our children into the array and return it
        found = found.concat(this.nw.inRegion(minx, miny, maxx, maxy), this.ne.inRegion(minx, miny, maxx, maxy), this.sw.inRegion(minx, miny, maxx, maxy), this.se.inRegion(minx, miny, maxx, maxy));
        return found;
    }
    draw(canvas, ctx, minx, miny, maxx, maxy) {
        var midx = (minx + maxx) / 2;
        var midy = (miny + maxy) / 2;
        if (this.nw) {
            ctx.beginPath();
            ctx.moveTo(minx * canvas.drawWidth, midy * canvas.drawHeight);
            ctx.lineTo(maxx * canvas.drawWidth, midy * canvas.drawHeight);
            ctx.moveTo(midx * canvas.drawWidth, miny * canvas.drawHeight);
            ctx.lineTo(midx * canvas.drawWidth, maxy * canvas.drawHeight);
            ctx.closePath();
            ctx.strokeStyle = "#FF0000";
            ctx.stroke();
            this.nw.draw(canvas, ctx, minx, miny, midx, midy);
            this.ne.draw(canvas, ctx, midx, miny, maxx, midy);
            this.sw.draw(canvas, ctx, minx, midy, midx, maxy);
            this.se.draw(canvas, ctx, midx, midy, maxx, maxy);
        } else for(var i = 0; i < this.bucket.length; i++){
            var p = this.bucket[i];
            var x = minx + (p.x - this.minx) / (this.maxx - this.minx) * (maxx - minx);
            var y = miny + (p.y - this.miny) / (this.maxy - this.miny) * (maxy - miny);
            ctx.fillStyle = "#0000FF";
            ctx.fillRect(x * canvas.drawWidth, y * canvas.drawHeight, 1, 1);
        }
    }
}



class $dc7180c53067d938$export$6a4eb2e7fc9e8903 extends (0, $c2d7541b81dd5a64$export$2e2bcd8739ae039) {
    constructor(capacity){
        super();
        this.data = [];
        this.capacity = capacity;
    }
    map(transform, capacity = Infinity) {
        return this.mapAsync((x, cb)=>cb(transform(x)), null, capacity);
    }
    mapAsync(transform, abort, capacity = Infinity) {
        return this.pipe(new $dc7180c53067d938$var$Transformer(transform, abort, capacity));
    }
    filter(predicate, capacity = Infinity) {
        return this.filterAsync((x, cb)=>cb(predicate(x)), null, capacity);
    }
    filterAsync(predicate, abort, capacity = Infinity) {
        return this.pipe(new $dc7180c53067d938$var$Filter(predicate, abort, capacity));
    }
    forEach(callback) {
        const fill = ()=>{
            while(this.canRead())callback(this.read());
        };
        this.on("can-read", fill);
        fill();
    }
    pipe(dest) {
        const fill = ()=>{
            // TODO: Break this up if the streams have unlimited bandwidth
            while(this.canRead() && dest.canWrite())dest.write(this.read());
        };
        this.on("can-read", fill);
        dest.on("can-write", fill);
        this.on("clear", dest.clear.bind(dest));
        fill();
        return dest;
    }
    clear() {
        this.data = [];
        this.emit("clear");
    }
    canRead() {
        return this.data.length > 0;
    }
    read() {
        const res = this.data.shift();
        if (this.data.length === this.capacity - 1) {
            // This prevents infinite recursion when piping A=>B=>C
            //   where A and C have unlimited bandwidth and B has a capacity of 1:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[can-write B]>...
            // If B has a capacity of greater than 1, this becomes:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)
            //                            >[can-read B]>(pipe B=>C)
            //                            >...
            //   because writing from B does not cause its length to be (capacity-1),
            //   so the [can-write B] event does not get triggered during (pipe B=>C).
            // This delays the [can-write B] event if capacity === 1, so it becomes:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[setTimeout]
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[setTimeout]
            //   ...
            // This will be slower, but hey, that's what you get ¯\_(ツ)_/¯
            if (this.capacity === 1) this.emitOnceAsync("can-write");
            else this.emit("can-write");
        }
        return res;
    }
    canWrite() {
        return this.data.length < this.capacity;
    }
    write(chunk) {
        if (this.canWrite()) {
            this.data.push(chunk);
            if (this.data.length === 1) this.emit("can-read");
        }
    }
}
class $dc7180c53067d938$var$Transformer extends $dc7180c53067d938$export$6a4eb2e7fc9e8903 {
    constructor(transform, abort, capacity){
        super(capacity);
        this.transform = transform;
        this.abort = abort;
        this.numReady = 0;
    }
    canRead() {
        return this.numReady > 0;
    }
    read() {
        this.numReady--;
        return super.read();
    }
    write(chunk) {
        super.write(chunk);
        this.transform(chunk, (data)=>{
            const index = this.data.indexOf(chunk);
            this.data.splice(index, 1);
            this.data.splice(this.numReady, 0, data);
            this.numReady++;
            if (this.numReady === 1) this.emit("can-read");
        });
    }
    clear() {
        if (this.abort) for(let i = this.numReady; i < this.data.length; i++)this.abort(this.data[i]);
        super.clear();
    }
}
class $dc7180c53067d938$var$Filter extends $dc7180c53067d938$export$6a4eb2e7fc9e8903 {
    constructor(predicate, abort, capacity){
        super(capacity);
        this.predicate = predicate;
        this.abort = abort;
    }
    write(chunk) {
        this.predicate(chunk, (x)=>x && super.write(chunk));
    }
    clear() {
        if (this.abort) this.data.forEach((data)=>this.abort(data));
        super.clear();
    }
}


function $c731a29915c32ed7$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $c731a29915c32ed7$export$d02631cccf789723(from, to, step) {
    if (typeof to === "undefined") {
        to = from;
        from = 0;
    }
    if (typeof step === "undefined") step = Math.sign(to - from);
    if (step === 0) return [];
    const res = [];
    while(step > 0 ? to > from : to < from){
        res.push(from);
        from += step;
    }
    return res;
}


const $d2433c734b6cef7c$export$3d8c2f653ac9d0b9 = document.getElementById.bind(document);
const $d2433c734b6cef7c$export$9fc9dd311300f9ff = function(canvas, context, scaleContext) {
    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
    var scale = devicePixelRatio / backingStoreRatio;
    canvas.style.width = canvas.width + "px";
    canvas.style.height = canvas.height + "px";
    canvas.drawWidth = canvas.width;
    canvas.drawHeight = canvas.height;
    $d2433c734b6cef7c$export$59b33278b5b2fc8a(canvas, context, canvas.width * scale, canvas.height * scale, scaleContext);
    return scale;
};
const $d2433c734b6cef7c$export$59b33278b5b2fc8a = function(canvas, context, width, height, scaleContext) {
    if (scaleContext === undefined) scaleContext = true;
    canvas.width = width;
    canvas.height = height;
    if (!scaleContext || !canvas.drawWidth || !canvas.drawHeight) {
        canvas.drawWidth = width;
        canvas.drawHeight = height;
    }
    if (scaleContext) {
        var scalex = width / canvas.drawWidth;
        var scaley = height / canvas.drawHeight;
        canvas.scalex = scalex;
        canvas.scaley = scaley;
        if (context instanceof CanvasRenderingContext2D) context.scale(scalex, scaley);
    }
};
const $d2433c734b6cef7c$export$98b5291b42c669ef = function(el, preferredWidth, preferredHeight, onresize) {
    preferredWidth = preferredWidth || el.clientWidth;
    preferredHeight = preferredHeight || el.clientHeight;
    onresize = onresize || function() {};
    var preferredRatio = preferredWidth / preferredHeight;
    var resize = function() {
        var style = window.getComputedStyle(el.parentElement, null);
        var width = parseInt(style.getPropertyValue("width"));
        var height = parseInt(style.getPropertyValue("height"));
        var newwidth = Math.min(width, preferredWidth);
        var newheight = Math.min(height, preferredHeight);
        if (newwidth > preferredRatio * newheight) newwidth = Math.floor(preferredRatio * newheight);
        else newheight = Math.floor(newwidth / preferredRatio);
        el.style.width = newwidth + "px";
        el.style.height = newheight + "px";
        onresize(el);
    };
    resize();
    window.addEventListener("resize", resize);
};
const $d2433c734b6cef7c$export$8b1a570463671010 = function(canvas, evt) {
    var x, y;
    // var pressed;
    if (evt instanceof MouseEvent) {
        x = evt.clientX;
        y = evt.clientY;
    // pressed = ~evt.buttons;
    } else if (window.TouchEvent && evt instanceof TouchEvent) {
        var touch = evt.changedTouches[0];
        x = touch.clientX;
        y = touch.clientY;
    // pressed = true;
    }
    var rect = canvas.getBoundingClientRect();
    return {
        x: (x - rect.left) * (canvas.drawWidth / canvas.clientWidth),
        y: (y - rect.top) * (canvas.drawHeight / canvas.clientHeight)
    };
};
const $d2433c734b6cef7c$export$1162121ddfdb1f6f = function(evt) {
    if (window.TouchEvent && evt instanceof TouchEvent) {
        if (evt.touches.length < 2) evt.preventDefault();
    }
};
function $d2433c734b6cef7c$export$9c30223ca0a664fb(el, obj, attr, cb = function() {}, options = {
    instant: true
}) {
    var setter = null;
    if (el.tagName === "INPUT") {
        if ("jscolor" in el) {
            // RGB color
            if (obj[attr] instanceof Array) {
                setter = ([r, g, b])=>el.jscolor.fromRGB(r, g, b);
                el.addEventListener("change", function() {
                    cb(obj[attr] = el.jscolor.rgb.map(Math.floor));
                });
            // Hex color
            } else {
                setter = (x)=>x && el.jscolor.fromString(x.replace(/^#/, ""));
                el.addEventListener("change", function() {
                    cb(obj[attr] = el.value ? "#" + el.jscolor.toString() : null);
                });
            }
        } else if (el.type === "checkbox") {
            setter = (x)=>el.checked = x;
            el.addEventListener("click", ()=>cb(obj[attr] = el.checked));
        // number input
        } else if (typeof obj[attr] === "number") {
            setter = (x)=>el.value = String(x);
            el.addEventListener(options.instant ? "input" : "change", function() {
                var value = +el.value;
                if (!isNaN(value)) cb(obj[attr] = value);
            });
            el.addEventListener("blur", ()=>el.value = String(obj[attr]));
        // string input
        } else {
            setter = (x)=>el.value = x;
            el.addEventListener(options.instant ? "input" : "change", function() {
                cb(obj[attr] = el.value);
            });
        }
    // select
    } else if (el.tagName === "SELECT") {
        setter = (x)=>el.value = x;
        el.addEventListener("change", ()=>cb(obj[attr] = el.value));
    }
    setter(obj[attr]);
    return (x)=>{
        obj[attr] = x;
        setter(x);
    };
}
function $d2433c734b6cef7c$export$bfb71cb8713b8641(obj, map) {
    var res = {};
    for(var key in map){
        var val = map[key];
        if (!(val instanceof Array)) val = [
            val
        ];
        res[key] = $d2433c734b6cef7c$export$9c30223ca0a664fb(val[0], obj, key, val[1], val[2]);
    }
    return res;
}
function $d2433c734b6cef7c$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.max(min, Math.min(num, max));
}
const $d2433c734b6cef7c$export$bdbb68221349f475 = function(minx, miny, width, height, r) {
    var r2 = r * r;
    var maxx = minx + width;
    var maxy = miny + height;
    var j, k;
    var points = [
        {
            x: Math.random() * width + minx,
            y: Math.random() * height + miny
        }
    ];
    var tree = new (0, $4811c2f0f662c58f$export$2e2bcd8739ae039)(minx, miny, maxx, maxy);
    var active = [];
    // start with a single, randomly placed point
    active.push(points[0]);
    tree.insert(points[0]);
    while(active.length > 0){
        // choose a random point that has free space around it
        var ind = Math.floor(Math.random() * active.length);
        var pt = active[ind];
        var acceptable = false;
        // do 30 random points before we give up
        for(k = 0; k < 30; k++){
            acceptable = true;
            // create a random point near to the current point
            var d = Math.random() * r + r;
            var theta = Math.random() * 2 * Math.PI;
            var px = pt.x + d * Math.cos(theta);
            var py = pt.y + d * Math.sin(theta);
            // if the point is out of bounds, it cannot be placed. Continue on.
            if (px < minx || px >= maxx || py < miny || py >= maxy) {
                acceptable = false;
                continue;
            }
            // get points close to the newly created one
            var nearby = tree.inRegion(px - r, py - r, px + r, py + r);
            for(j = 0; j < nearby.length; j++){
                var dx = px - nearby[j].x;
                var dy = py - nearby[j].y;
                // if we are too close to a neighbor, this point cannot be placed
                if (dx * dx + dy * dy < r2) {
                    acceptable = false;
                    break;
                }
            }
            // if there are no neighbors that are too close, and we are in bounds
            if (acceptable) {
                var newpt = {
                    x: px,
                    y: py
                };
                // insert into the tree and the active points list
                tree.insert(newpt);
                points.push(newpt);
                active.push(newpt);
                break;
            }
        }
        // if we could not place a point, assume the area around this point is filled.
        // remove the current point from the active list.
        if (!acceptable) active.splice(ind, 1);
    }
    // var cvs = $('draw-canvas');
    // var ctx = cvs.getContext('2d');
    // for (i = 0; i < points.length; i++) {
    //   for (j = 0; j < points.length; j++) {
    //     ctx.fillRect(cvs.drawWidth / 2 + (points[j].x - points[i].x),
    //       cvs.drawHeight / 2 + (points[j].y - points[i].y), 1, 1);
    //   }
    // }
    // tree.draw(cvs, ctx, 0, 0, 1, 1);
    return points;
};



window.onload = function() {
    var drawCanvas = (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("draw-canvas");
    var traceCanvas = (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("trace-canvas");
    var drawContext = drawCanvas.getContext("2d");
    var traceContext = traceCanvas.getContext("2d");
    var particles = [];
    var paused = true;
    var runInterval;
    var doubletap = false;
    var mouseparticle = null;
    var newgroup = null;
    var groupvel = null;
    var width, height;
    var options = {
        bounce: true,
        trace: true,
        gravity: 20.0,
        decay: 0,
        groupSize: 40,
        groupRadius: 8,
        groupColor: null,
        mouseDensity: 50,
        particleRadius: 1,
        particleDensity: 1,
        fixedParticles: false,
        traceNew: true
    };
    var inputs = {
        gravInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("gravity"),
        decayInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("decay"),
        groupSizeInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("group-size"),
        groupRadiusInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("group-radius"),
        groupColorInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("group-color"),
        mouseDensityInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("mouse-density"),
        particleRadiusInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("particle-radius"),
        particleDensityInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("particle-density"),
        fpcheck: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("fixed-particles"),
        tpcheck: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("trace-particles"),
        bocheck: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("bounce"),
        trcheck: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("trace"),
        pauseBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("pause"),
        clearBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("clear"),
        clearTraceBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("clear-trace"),
        saveBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("save-btn"),
        saveImg: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("save-img")
    };
    init();
    function init() {
        (0, $d2433c734b6cef7c$export$9fc9dd311300f9ff)(drawCanvas, drawContext);
        (0, $d2433c734b6cef7c$export$9fc9dd311300f9ff)(traceCanvas, traceContext);
        var canvases = (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("canvases");
        (0, $d2433c734b6cef7c$export$98b5291b42c669ef)(canvases, 500, 500, function(el) {
            drawCanvas.style.width = traceCanvas.style.width = canvases.style.width;
            drawCanvas.style.height = traceCanvas.style.height = canvases.style.height;
        });
        width = drawCanvas.drawWidth;
        height = drawCanvas.drawHeight;
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.gravInput, options, "gravity");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.decayInput, options, "decay");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.groupSizeInput, options, "groupSize");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.groupRadiusInput, options, "groupRadius");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.groupColorInput, options, "groupColor");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.mouseDensityInput, options, "mouseDensity");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.particleRadiusInput, options, "particleRadius");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.particleDensityInput, options, "particleDensity");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.fpcheck, options, "fixedParticles");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.tpcheck, options, "traceNew");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.bocheck, options, "bounce");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.trcheck, options, "trace");
        inputs.pauseBtn.addEventListener("click", function() {
            setPaused(!paused);
        });
        inputs.clearBtn.addEventListener("click", clear);
        inputs.clearTraceBtn.addEventListener("click", clearTrace);
        inputs.saveBtn.addEventListener("click", function() {
            inputs.saveImg.src = traceCanvas.toDataURL();
        });
        drawCanvas.addEventListener("mousedown", mouseDown);
        drawCanvas.addEventListener("mousemove", mouseMove);
        drawCanvas.addEventListener("mouseup", mouseUp);
        drawCanvas.addEventListener("mouseleave", mouseUp);
        window.addEventListener("keydown", keyFunc);
        drawCanvas.addEventListener("touchstart", touchDown);
        drawCanvas.addEventListener("touchmove", touchMove);
        drawCanvas.addEventListener("touchend", touchUp);
        addGroup(drawCanvas.drawWidth / 2, drawCanvas.drawHeight / 2);
        setPaused(false);
    }
    function Particle(x, y, r, d, c, trace, fixed) {
        this.x = x;
        this.y = y;
        this.radius = r;
        this.mass = r * r * Math.PI * d;
        this.color = c;
        this.trace = trace || false;
        this.fixed = fixed || false;
    }
    Particle.prototype.vx = 0;
    Particle.prototype.vy = 0;
    Particle.prototype.mx = 0;
    Particle.prototype.my = 0;
    Particle.prototype.update = function(time) {
        this.vx = this.mx + this.vx * (1 - options.decay);
        this.vy = this.my + this.vy * (1 - options.decay);
        if (options.bounce) {
            /* if (this.x < this.radius && this.vx < 0) {
        this.x = this.radius*2 - this.x;
        this.vx = -this.vx;
      } else if (this.x > width - this.radius && this.vx > 0) {
        this.x = width*2 - this.x;
        this.vx = -this.vx;
      }

      if (this.y < this.radius && this.vy < 0) {
        this.y = this.radius*2 - this.y;
        this.vy = -this.vy;
      } else if (this.y > height - this.radius && this.vy > 0) {
        this.y = height*2 - this.y;
        this.vy = -this.vy;
      } */ if (this.x < this.radius && this.vx < 0 || this.x > width - this.radius && this.vx > 0) this.vx = -this.vx;
            if (this.y < this.radius && this.vy < 0 || this.y > height - this.radius && this.vy > 0) this.vy = -this.vy;
        }
        if (!this.fixed) {
            this.x += this.vx * time;
            this.y += this.vy * time;
        }
        // if (this.mass === 0) console.log(Math.sqrt(this.mx*this.mx + this.my*this.my));
        this.mx = 0;
        this.my = 0;
    };
    Particle.prototype.attract = function(p, time) {
        var dx = this.x - p.x;
        var dy = this.y - p.y;
        var dsq = dx * dx + dy * dy;
        if (dsq === 0) return;
        var dr = this.radius + p.radius;
        var drsq = dr * dr;
        if (dsq <= drsq) dsq = drsq;
        // packing density ~= b / a
        // force ~= b
        // reactivity ~= a
        // var d4 = dsq * dsq;
        // var d8 = d4 * d4;
        //
        // var a = 2.5e6;
        // var b = 2.5e3;
        //
        // var e = ((b * d4 - a) / d8) * time + (this.mass * p.mass * options.gravity * time / dsq);
        // var rx = dx * e;
        // var ry = dy * e;
        //
        // p.mx += rx / p.mass;
        // p.my += ry / p.mass;
        //
        // this.mx -= rx / this.mass;
        // this.my -= ry / this.mass;
        var e = options.gravity * time / dsq;
        var rx = dx * e;
        var ry = dy * e;
        p.mx += rx * this.mass;
        p.my += ry * this.mass;
        this.mx -= rx * p.mass;
        this.my -= ry * p.mass;
    };
    function addGroup(x, y) {
        particles = particles.concat(newGroup(x, y));
    }
    function newGroup(x, y) {
        if (x === undefined) x = Math.random() * width;
        if (y === undefined) y = Math.random() * height;
        var color = options.groupColor || (0, $7d9f01ff152f00eb$export$f3c6ed4330abfc18)();
        var group = [];
        for(var i = 0; i < options.groupSize; i++){
            // var min = (options.particleRadius + 2) / Math.sin(Math.PI / options.groupSize)
            var d = options.groupRadius * i / options.groupSize; // + min;
            var px = x + d * Math.cos(i);
            var py = y + d * Math.sin(i);
            group[group.length] = new Particle(px, py, options.particleRadius, options.particleDensity, color, options.traceNew, options.fixedParticles);
        }
        return group;
    }
    function draw() {
        var i;
        drawContext.clearRect(0, 0, drawCanvas.drawWidth, drawCanvas.drawHeight);
        if (!options.trace) clearTrace();
        function drawParticle(ctx, p) {
            ctx.beginPath();
            ctx.arc(p.x, p.y, p.radius, 0, 2 * Math.PI);
            ctx.closePath();
            ctx.fillStyle = p.color;
            ctx.fill();
        }
        for(i = 0; i < particles.length; i++){
            drawParticle(drawContext, particles[i]);
            drawContext.strokeStyle = "#000000";
            drawContext.lineWidth = 0.5;
            drawContext.stroke();
            if (options.trace && particles[i].trace) drawParticle(traceContext, particles[i]);
        }
        if (mouseparticle) drawParticle(drawContext, mouseparticle);
        if (newgroup) for(i = 0; i < newgroup.length; i++)drawParticle(drawContext, newgroup[i]);
        if (groupvel) {
            drawContext.beginPath();
            drawContext.moveTo(groupvel.ox, groupvel.oy);
            drawContext.lineTo(groupvel.ox + groupvel.x, groupvel.oy + groupvel.y);
            drawContext.closePath();
            drawContext.strokeStyle = "#00FF00";
            drawContext.stroke();
        }
    }
    function update(time) {
        for(var i = 0; i < particles.length; i++){
            for(var j = i + 1; j < particles.length; j++)particles[i].attract(particles[j], time);
            if (mouseparticle) particles[i].attract(mouseparticle, time);
            particles[i].update(time);
        }
        draw();
    }
    function clear() {
        particles = [];
        draw();
    }
    function clearTrace() {
        traceContext.clearRect(0, 0, traceCanvas.drawWidth, traceCanvas.drawHeight);
    }
    function setPaused(p) {
        if (p && !paused) clearInterval(runInterval);
        else if (paused) runInterval = setInterval(function() {
            update(0.015);
        }, 15);
        paused = p;
        inputs.pauseBtn.innerHTML = p ? "Resume" : "Pause";
    }
    function mouseDown(evt) {
        var mousepos = (0, $d2433c734b6cef7c$export$8b1a570463671010)(drawCanvas, evt);
        if (evt.ctrlKey || evt.metaKey) {
            newgroup = newGroup(mousepos.x, mousepos.y);
            groupvel = {
                ox: mousepos.x,
                oy: mousepos.y,
                x: 0,
                y: 0
            };
        } else mouseparticle = new Particle(mousepos.x, mousepos.y, 1, options.mouseDensity, "#FFFF00", false, false);
        draw();
    }
    function mouseUp(evt) {
        if (newgroup) {
            newgroup.forEach(function(p) {
                p.vx = groupvel.x;
                p.vy = groupvel.y;
            });
            groupvel = null;
            particles = particles.concat(newgroup);
            newgroup = null;
        }
        mouseparticle = null;
        draw();
    }
    function mouseMove(evt) {
        var mousepos = (0, $d2433c734b6cef7c$export$8b1a570463671010)(drawCanvas, evt);
        if (groupvel) {
            groupvel.x = mousepos.x - groupvel.ox;
            groupvel.y = mousepos.y - groupvel.oy;
        }
        if (mouseparticle) {
            mouseparticle.x = mousepos.x;
            mouseparticle.y = mousepos.y;
        }
        draw();
    }
    function touchDown(evt) {
        (0, $d2433c734b6cef7c$export$1162121ddfdb1f6f)(evt);
        var mousepos = (0, $d2433c734b6cef7c$export$8b1a570463671010)(drawCanvas, evt);
        if (doubletap) {
            newgroup = newGroup(mousepos.x, mousepos.y);
            groupvel = {
                ox: mousepos.x,
                oy: mousepos.y,
                x: 0,
                y: 0
            };
            draw();
        } else {
            mouseparticle = new Particle(mousepos.x, mousepos.y, 1, options.mouseDensity, "#FFFF00", false, false);
            doubletap = true;
            setTimeout(function() {
                doubletap = false;
            }, 400);
        }
    }
    function touchMove(evt) {
        (0, $d2433c734b6cef7c$export$1162121ddfdb1f6f)(evt);
        mouseMove(evt);
    }
    function touchUp(evt) {
        (0, $d2433c734b6cef7c$export$1162121ddfdb1f6f)(evt);
        mouseUp(evt);
    }
    function keyFunc(evt) {
        switch(evt.keyCode){
            case 13:
                clear();
                break;
        }
    }
};


//# sourceMappingURL=index.64b6f5d5.js.map
